import {GET_REWARD_LIST,GET_REWARD_HISTORY_LIST} from './rewardListTypes'
import {Reward} from "../../models/reward/reward"
import {RewardHistory} from "../../models/reward/rewardHistory"

export default {
  [GET_REWARD_LIST](state, data) {
    state.rewardData = data;
    let reward_arr = [];
    for(let i = 0; i < data.items.length; i++) {
      reward_arr.push(new Reward(data.items[i]));
    }
    state.rewardList = reward_arr;
  },
  [GET_REWARD_HISTORY_LIST](state, data) {
    state.rewardHistoryData = data;
    let reward_history_arr = [];
    for(let i = 0; i < data.items.length; i++) {
      reward_history_arr.push(new RewardHistory(data.items[i]));
    }
    state.rewardHistoryList = reward_history_arr;
  },
}
